import useFetch from "./use-fetch";

const API_URL = "https://recherche-entreprises.api.gouv.fr/search";
const fallbackData = { results: [] };

export default function useSiretSearch(query) {
  const { data, ...rest } = useFetch(query.length > 2 ? API_URL : null, {
    params: {
      q: query,
      per_page: 5,
    },
    fallbackData,
  });

  return {
    suggestions: data?.results.map((result) => {
      const dirigeant = result.dirigeants?.find(
        (d) => d.type_dirigeant === "personne physique",
      );
      return {
        siren: result.siren,
        siret: result.siege?.siret,
        nom: result.nom_complet,
        adresse: result.siege?.adresse,
        rue: buildRue(result.siege),
        cp: result.siege?.code_postal,
        ville: result.siege?.libelle_commune,
        dirigeantNom: dirigeant?.nom || "",
        dirigeantPrenom: capitalizeFirstLetter(
          dirigeant?.prenoms?.split(" ")[0] || "",
        ),
        dateDebutActivite:
          result.siege?.date_debut_activite || result.date_creation || "",
        numeroTva: result.siren ? computeTva(result.siren) : "",
        socType: NATURE_JURIDIQUE_MAP[result.nature_juridique] || "",
      };
    }),
    ...rest,
  };
}

function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

const NATURE_JURIDIQUE_MAP = {
  5505: "SA",
  5510: "SA",
  5710: "SAS",
  5720: "SASU",
  6540: "SCI",
  5499: "SARL",
  5498: "SARL",
  5560: "SNC",
  9220: "Association",
  9221: "Association",
  1000: "Entreprise individuelle",
};

function computeTva(siren) {
  const sirenNum = parseInt(siren, 10);
  if (isNaN(sirenNum)) return "";
  const key = (12 + 3 * (sirenNum % 97)) % 97;
  return `FR${String(key).padStart(2, "0")}${siren}`;
}

function buildRue(siege) {
  if (!siege) return "";
  const parts = [];
  if (siege.numero_voie) parts.push(siege.numero_voie);
  if (siege.type_voie) parts.push(siege.type_voie);
  if (siege.libelle_voie) parts.push(siege.libelle_voie);
  return (
    parts.join(" ") || siege.adresse?.split(" ").slice(0, -3).join(" ") || ""
  );
}
